import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import {
  WORKING_EQUIPMENT_ALLOCATION_APPROVED_PREFIX_URL,
  WORKING_EQUIPMENT_ALLOCATION_MY_APPROVE_PREFIX_URL,
  WORKING_EQUIPMENT_ALLOCATION_PREFIX_URL,
  WORKING_EQUIPMENT_ALLOCATION_REPORT_PREFIX_URL,
  WORKING_EQUIPMENT_ALLOCATION_WAITING_APPROVE_PREFIX_URL,
} from './constants/config.working-equipment-allocation'

const ListPage = lazy(
  () => import('./pages/ListPage.All.WorkingEquipmentAllocation')
)
const ListPageChoToiDuyet = lazy(
  () => import('./pages/ListPage.WaitingApproval.WorkingEquipmentAllocation')
)
const ListPageDuocToiDuyet = lazy(
  () => import('./pages/ListPage.MyApprove.WorkingEquipmentAllocation')
)
const ListPageDaDuocDuyet = lazy(
  () => import('./pages/ListPage.Approve.WorkingEquipmentAllocation')
)

const ReportPageByPhongBan = lazy(
  () => import('./pages/ReportPage.ByPhongBan.WorkingEquipmentAllocation')
)
const ReportPageByResource = lazy(
  () =>
    import('./pages/ReportPage.ByWorkingEquipment.WorkingEquipmentAllocation')
)
const DetailPage = lazy(
  () => import('./pages/DetailPage.WorkingEquipmentAllocation')
)

const listRouters: AppRouterItem[] = [
  {
    path: WORKING_EQUIPMENT_ALLOCATION_PREFIX_URL,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPage />
      </LoadingLazyComponents>
    ),
  },
  {
    path: WORKING_EQUIPMENT_ALLOCATION_WAITING_APPROVE_PREFIX_URL,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageChoToiDuyet />
      </LoadingLazyComponents>
    ),
  },
  {
    path: WORKING_EQUIPMENT_ALLOCATION_MY_APPROVE_PREFIX_URL,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageDuocToiDuyet />
      </LoadingLazyComponents>
    ),
  },
  {
    path: WORKING_EQUIPMENT_ALLOCATION_APPROVED_PREFIX_URL,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageDaDuocDuyet />
      </LoadingLazyComponents>
    ),
  },
]

const detailRouters: AppRouterItem[] = listRouters.map(({ path }) => ({
  path: `${path}/:allocationId`,
  element: (
    <LoadingLazyComponents loadingType="skeleton">
      <DetailPage />
    </LoadingLazyComponents>
  ),
}))

const WorkingEquipmentAllocationRouters: AppRouterItem[] = [
  ...listRouters,
  ...detailRouters,
  {
    path: `${WORKING_EQUIPMENT_ALLOCATION_REPORT_PREFIX_URL}/by-phong-ban`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ReportPageByPhongBan />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${WORKING_EQUIPMENT_ALLOCATION_REPORT_PREFIX_URL}/by-working-equipment`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ReportPageByResource />
      </LoadingLazyComponents>
    ),
  },
]

export default WorkingEquipmentAllocationRouters
